export const DEFAULT_STRINGIFIED_DATE_TIME_FORMAT_IN_FORM =
  "DD/MM/YYYY hh:mm:ss a";
export const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";
export const US_FORMAT_DATE = "MM/DD/YYYY hh:mm:ss A";
